import { useMemo } from 'react';

import { createQueueNodeAttributes } from 'components/powerFlowShared/components/nodeTypes/canvas/queue';
import { FlowType } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { AutomationExtraData } from 'flow-builder/types/extraData';
import type {
  GenericNodeAttributes,
  GenericNodeProps,
} from 'flow-builder/types/node';

import { QueueModal } from '../../modals';

export type Payload = {
  transferToQueueId: null | string;
  queueName: null | string;
};

type QueueNodeAttributes = GenericNodeAttributes<Payload, AutomationExtraData>;
type QueueNodeProps = GenericNodeProps<Payload, AutomationExtraData>;

export const QueueNodeAutomationAttributes: QueueNodeAttributes = {
  ...createQueueNodeAttributes(FlowType.FLOW_TYPE_AUTOMATION),
  translateScopeVariables: undefined,
  translatePayload: () => [],
  updateConnection: (node) => node,
  NodeContent: QueueNode,
  ActionModal: QueueModal,
};

export function QueueNode({ node }: QueueNodeProps): JSX.Element {
  const { payload } = node;
  const { queueName } = payload;

  return (
    <TextContent>
      {useMemo(
        () => (
          <TextEllipsis>
            <Text weight="semibold" text={queueName ?? 'Re-offer'} />
          </TextEllipsis>
        ),
        [queueName],
      )}
    </TextContent>
  );
}
